import userReducer from "./userReducer";
import leaveReducer from "./leaveReducer";
import holidayReducer from "./holidayReducer";
import salarySettingReducer from "./salarySettingReducer";
import salaryList from "./salaryListReducer";
import { combineReducers } from "redux";
import assetReducer from "./assetReducer";
import assignassetReducer from "./assignassetReducer";
import leaveBalanceReducer from "./leaveBalanceReducer";
import documentTypeReducer from "./documentReducer";
import projectTypeReducer from "./projectReducer";
import timeEntryReducer from "./timeEntryReducer";
import hrReducer from "./hrReducer";
import financialReportReducer from "./financialReducer";

const initialState = {
  sidebarShow: "responsive",
};

const changeState = (state = initialState, { type, ...rest }) => {
  switch (type) {
    case "set":
      return { ...state, ...rest };
    default:
      return state;
  }
};

const rootReducer = combineReducers({
  sidebarState: changeState,
  asset: assetReducer,
  users: userReducer,
  leaves: leaveReducer,
  holidays: holidayReducer,
  salarySetting: salarySettingReducer,
  salaryList: salaryList,
  assign: assignassetReducer,
  balance: leaveBalanceReducer,
  document: documentTypeReducer,
  projects: projectTypeReducer,
  timeEntry: timeEntryReducer,
  hrPolicy: hrReducer,
  financialReport: financialReportReducer,
});

export default rootReducer;
